/**
 * Privacy / Terms links for the unauthenticated screens.
 *
 * They point at the apex domain rather than a route in this SPA on purpose:
 * Google's OAuth verification requires the privacy policy to be publicly
 * reachable without a login and served from the same domain as the homepage
 * that links to it. The pages live in `infra/jcseo/edge/legal.yaml`.
 */
export default function LegalLinks({ className = '' }: { className?: string }) {
  return (
    <p className={`text-center text-xs text-gray-500 dark:text-gray-400 ${className}`}>
      <a
        href="https://lumnian.com/privacy"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-gray-700 dark:hover:text-gray-200 hover:underline"
      >
        Privacy Policy
      </a>
      <span className="mx-2">&middot;</span>
      <a
        href="https://lumnian.com/terms"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-gray-700 dark:hover:text-gray-200 hover:underline"
      >
        Terms of Service
      </a>
    </p>
  );
}
